import BeforeYouGoSheet from "../../components/BeforeYouGoSheet/BeforeYouGoSheet"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import { PurchasProvider } from "../../context/purchaseContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import AlternativeBottomPaywall from "../AlternativeBottomPaywall/AlternativeBottomPaywall"

const DefaultPaywall = () => {
  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <FullScreenPage>
          <AlternativeBottomPaywall />
        </FullScreenPage>
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

export default DefaultPaywall
